import { render, staticRenderFns } from "./arrange.vue?vue&type=template&id=52f197ac&scoped=true&"
import script from "./arrange.vue?vue&type=script&lang=ts&"
export * from "./arrange.vue?vue&type=script&lang=ts&"
import style0 from "./arrange.vue?vue&type=style&index=0&id=52f197ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f197ac",
  null
  
)

export default component.exports